import { FC, useState } from 'react';
import CollectDrawer from '../CollectDrawer';
import IconFont from '@/common/components/IconFont';
import cs from 'classnames';
import styles from './index.module.less';

// const PopoverContent: FC<{
//   setOpenCollect, // 打开我的收藏
//   setIsBatchCollect, // 设置批量收藏状态
//   setOpenPopover, // 关闭Popover
// }> = ({
//   setOpenCollect, // 打开我的收藏
//   setIsBatchCollect, // 设置批量收藏状态
//   setOpenPopover, // 关闭Popover
// }) => {
//   // 批量收藏是否是隐藏状态
//   // const isHideBatchCollect = useMemo(() => {
//   //   if (realListData?.length === 0) return true;
//   //   const { key } = rankSort || {};
//   //   // 有排名 || 生成中的才能进入批量收藏
//   //   if (key) {
//   //     return key === collecting;
//   //   }
//   //   return false;
//   // }, [rankSort, realListData]);
//   const methods = useMethods({
//     mineCollect: () => {
//       setOpenCollect(true);
//     },
//     batchCollect: () => {
//       setOpenPopover(false);
//       setIsBatchCollect((state) => !state);
//     },
//   });
//   return <div className='c-222 ft-12'>
//     <div onClick={methods.mineCollect} className={styles.contentItem}>
//       我的收藏
//     </div>
//     {/* {
//       isHideBatchCollect ? <></> : <>
//         <Divider style={{ margin: '8px 0', borderTopColor: '#eee' }}/>
//         <div onClick={methods.batchCollect} className={styles.contentItem}>
//           {isBatchCollect ? '退出' : ''}批量收藏
//         </div>
//       </>
//     } */}
//   </div>;
// };

/**
 * @Description 我的收藏入口
 */
const Entrance: FC<{
  requirementId, // 需求id
  customEntry?, // 可以自定义进入我的收藏列表按钮部分
  setIsBatchCollect,
}> = ({
  requirementId, // 需求id
  customEntry, // 可以自定义进入我的收藏列表按钮部分
  // setIsBatchCollect,
}) => {
  const [openCollect, setOpenCollect] = useState(false); // 是否打开我的收藏抽屉
  // const [openPopover, setOpenPopover] = useState<boolean>(false); // 是否展示popover
  return (
    <>
      {
        customEntry || <div className={cs('pointer', styles.popoverCon)}>
          <IconFont iconHref={'iconic_shoucang1'} className={'fs-20'} onClick={() => setOpenCollect(true)}/>
        </div>
      }

      <CollectDrawer requirementId={requirementId} open={openCollect} setOpen={setOpenCollect} />
    </>
  );
};

export default Entrance;
